module.exports = __webpack_public_path__ + "img/3WetterTaft.a849a778.svg";